import React from "react";
import { useNavigate } from "react-router-dom";
import { Divider, Button } from "@mui/material";
import PropTypes from "prop-types";
import routes from "../../routes";
import { ReactComponent as LogoSmallColor } from "../../assets/images/logo-small-color.svg";
import useRedirectionUrl from "../../utils/useRedirectionUrl";

import { StyledApplicationErrorHeader, StyledApplicationError } from "./styled";

//ro-assist-brd2-3
const accountComparisionRoute = {
  link: routes.quickapplyLanding,
  label: "Back to home"
};
const getParts = text => text?.split("$") || [];

export const ApplicationError = ({
  icon,
  text,
  link,
  screeningType = "",
  redirectToBAU = false,
  buttons = [accountComparisionRoute],
  isEFRDeclinedScreen = false
}) => {
  const navigate = useNavigate();
  const { redirectToExternalURL } = useRedirectionUrl();

  const redirectTo = (route, external) => {
    if (external) {
      let routeTo = route;
      if (redirectToBAU) {
        routeTo = redirectToExternalURL(route);
      }
      window.location.href = routeTo;
    } else {
      navigate(route);
      window.location.reload();
    }
  };

  const buttonClass = buttons.length > 1 ? "appErrorMultipleLink" : "appErrorLink";

  const navigateToBAU = () => {
    const externalURL = process.env.REACT_APP_BAU_URL + "/business/applicantinfo-redirect";
    const url = redirectToExternalURL(externalURL);
    window.location.href = url;
  };

  let declineMessage;

  if (isEFRDeclinedScreen) {
    declineMessage = (
      // Assigning data-testid="EFR_CHECK_ERROR" to the div for easier searching
      <div className={"info"} data-testid="EFR_CHECK_ERROR">
        Dear Customer, we were unable to complete your facial recognition process successfully. Not
        to worry! You may still proceed with our alternative application platform by clicking this
        secure link.&nbsp;
        <span
          className="externalLink"
          onClick={() => navigateToBAU()}
          data-testid="EFRDeclineNavigateToBAULink"
        >
          Click here
        </span>
      </div>
    );
  } else {
    declineMessage = <div className={"info"} dangerouslySetInnerHTML={{ __html: text }} />;
  }

  return (
    <>
      <StyledApplicationErrorHeader className={"small-menu-show"}>
        <LogoSmallColor />
      </StyledApplicationErrorHeader>
      <StyledApplicationError>
        <div className={"appErrorStatus"}>
          <div className={"errorMessage"}>
            {screeningType !== 403 ? (
              <>
                {getParts(text).map((part, index, parts) =>
                  index === 0 && parts.length > 1 ? (
                    <div key={`title-${part}`} className={"title"}>
                      {part}
                    </div>
                  ) : (
                    <p key={`subtitle-${part}`} className={"subTitle"}>
                      {part}
                    </p>
                  )
                )}
              </>
            ) : (
              <>
                <div className={"title"}>
                  {"Thank You for choosing our bank assisted application process"}
                </div>
                {declineMessage}
              </>
            )}

            <Divider className={"divider"} />
          </div>
          {/* ro-assist-brd2-3 */}
          {link && (
            <div className={"linkErrorWrapper"}>
              {buttons.map(btn => (
                <Button
                  key={btn.label}
                  onClick={() => redirectTo(btn.link, btn.external)}
                  className={buttonClass}
                >
                  {btn.label}
                </Button>
              ))}
            </div>
          )}
        </div>
      </StyledApplicationError>
    </>
  );
};

ApplicationError.propTypes = {
  icon: PropTypes.node,
  text: PropTypes.string,
  link: PropTypes.string,
  screeningType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  redirectToBAU: PropTypes.bool,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      label: PropTypes.string,
      external: PropTypes.bool
    })
  ),
  isEFRDeclinedScreen: PropTypes.bool
};
